import React from 'react';
import { Flex, Text } from 'rebass';
import DocWithSample from '../../../static/DocWithSampleLarge.png';
import Odometer from '../components/RollingNumbers';
import styled from 'styled-components';
import { Clock } from '../icons/Clock';

const CText = styled(Text)`
  font-size: 50px;
  line-height: 90px;
  margin-bottom: 24px;

  @media screen and (max-width: 52em) {
    font-size: 32px;
    line-height: 50px;
  }
`;

export const TimeWithDoctorBackground = () => {
  return (
    <Flex style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex: 1 }}>
      <svg width="90%" viewBox="0 0 640 724" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: 0, top: 48 }}>
        <path
          d="M3.72974 361.339C21.9137 281.018 55.1433 209.432 108.424 147.162C124.479 128.809 139.6 109.655 153.729 89.773C206.657 13.5214 282.966 -6.85915 368.465 2.23461C458.988 11.8661 540.767 46.2223 606.413 110.785C668.852 172.2 702.05 249.897 702.135 336.895C702.171 373.388 684.683 411.973 668.051 446.144C630.97 522.342 578.718 588.097 520.27 649.627C463.662 709.196 394.385 728.403 316.828 722.956C237.771 717.411 164.273 690.855 97.0701 649.838C31.7719 609.982 2.47491 547.255 0.282278 471.917C-0.798641 435.132 2.44013 398.2 3.72974 361.339Z"
          fill="#FEFCFB"
          fill-opacity="0.3"
        />
      </svg>
      <img
        src={DocWithSample}
        height={'25%'}
        style={{
          margin: '0 auto',
          height: 'calc(100vh / 4)',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      />
    </Flex>
  );
};

export const TimeWithDoctor = ({ minutesSpentAppointment = 0 }) => {
  return (
    <Flex style={{ alignItems: 'center', paddingTop: '48px', height: '100%', zIndex: 100, flexDirection: 'column' }}>
      <CText style={{ fontWeight: 700, textAlign: 'center' }}>You've had some quality time with your provider</CText>
      <Odometer
        delay={0}
        startNumber={0}
        to={minutesSpentAppointment}
        style={{ color: '#F8A294', fontSize: window.matchMedia('(min-width: 52em)').matches ? 90 : 56, fontWeight: 'bold', width: '100%' }}
      />
      <Text style={{ textAlign: 'center' }}>minutes</Text>
    </Flex>
  );
};
